import Navigation from './navigation';
import Autocomplete from '../search/autocomplete';

export default class Header {
  private readonly nav: Navigation;
  private readonly autocomplete?: Autocomplete;

  constructor() {
    this.nav = new Navigation(document.querySelector('.js-navigation') as HTMLElement);

    const search = $('.js-site-search-input');
    if (search.length > 0) {
      this.autocomplete = new Autocomplete(search);
    }
  }
}
